/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  Button, TextField,
} from '@material-ui/core';

import { useHistory } from 'react-router-dom';
import ContainerComponent from '../../components/container';
import NavCommon from '../../components/navCommon';
import {
  Cards, Footer, Row, RowCategory, Category, ContainerLoading, NameCategory,
} from './styles';
import axios from '../../services/axiosServicesAgendamentos';
import Input from '../../components/input';
import LoadingCommon from '../../components/LoadingCommon';

interface Props {
  codigoCategoriaLocal: any;
  limiteReservasGeralPorUsuario: any;
  limiteReservasTurnoManhaPorUsuario: any;
  limiteReservasTurnoTardePorUsuario: any;
  limiteReservasTurnoNoitePorUsuario: any;
  nomeCategoriaLocal: string;
  dobraPosicaoPermitida: boolean;
}

const Buffer = () => {
  const history = useHistory();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [loadingData, setLoadingData] = React.useState<boolean>(false);
  const [buffer, setbuffer] = useState('');
  const [limiteAgendamentosTurnosPorUsuario, setLimit] = useState(0);
  const [posicoesOnline, setposicoesOn] = useState(0);
  const [qtdQuiosque, setQtdQuiosque] = useState(0);
  const [category, setCategory] = useState<Array<Props>>();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoadingData(true);
      const response = await axios.get('admin/agendas/v1/configuracoes-reserva-posicoes');
      const { data: dataConfig } = response.data;

      setbuffer(dataConfig?.bufferEntreTurnos);
      setLimit(dataConfig?.limiteReservasPorUsuario);
      setposicoesOn(dataConfig?.qtdPosicoesASeremLiberadosParaCatOnline);
      setQtdQuiosque(dataConfig?.qtdReservaPosicoesCatEstoqueQuiosqueParaLiberacaoOnline);
      setCategory(dataConfig?.regrasPorCategoriasLocais);

      setLoadingData(false);
    } catch (error) {
      setLoadingData(false);
      toast.error('⚠ Não foi possível carregar os dados!');
    }
  };

  const change = (event: any) => {
    setbuffer(event.target.value);
  };

  const saveOrEdit = async () => {
    try {
      if (!limiteAgendamentosTurnosPorUsuario
          || !buffer
          || !qtdQuiosque
          || !posicoesOnline
      ) {
        toast.error('⚠ Informe todos os dados!');
        return;
      }
      setLoading(true);
      await axios.put('admin/agendas/v1/configuracoes-reserva-posicoes', {
        bufferEntreTurnos: buffer,
        limiteReservasPorUsuario: limiteAgendamentosTurnosPorUsuario,
        qtdReservaPosicoesCatEstoqueQuiosqueParaLiberacaoOnline: qtdQuiosque,
        qtdPosicoesASeremLiberadosParaCatOnline: posicoesOnline,
        regrasPorCategoriasLocais: category?.map((item) => ({
          codigoCategoriaLocal: item.codigoCategoriaLocal,
          // dobraPosicaoPermitida: item.dobraPosicaoPermitida,
          limiteReservasTurnoManhaPorUsuario: Number(item.limiteReservasTurnoManhaPorUsuario),
          limiteReservasTurnoTardePorUsuario: Number(item.limiteReservasTurnoTardePorUsuario),
          limiteReservasTurnoNoitePorUsuario: Number(item.limiteReservasTurnoNoitePorUsuario),
          limiteReservasGeralPorUsuario: Number(item.limiteReservasGeralPorUsuario),
        })),
      });
      setLoading(false);
      toast.success('Regras de reserva salva sucesso!');
    } catch (error: any) {
      setLoading(false);
      toast.error(`⚠ ${error?.data?.notifications?.map((item: any) => `${item.message}\n`)}`);
    }
  };

  return (
    <>
      <NavCommon
        breadcrumbs={[]}
        hasOnChange={false}
        onBack={() => { history.goBack(); }}
        onChange={() => {
        }}
      />
      <ContainerComponent component="div" maxWidth="lg">
        {loadingData ? (
          <ContainerLoading>
            <LoadingCommon />
          </ContainerLoading>
        ) : (
          <Cards>
            <Row>
              <div style={{ width: '100%' }}>
                <span style={{ fontSize: 12, color: '#787878' }}>
                  Intervalo de tempo mínimo para o corretor conseguir
                  reservar locais diferentes em turnos subsequentes
                </span>
                <TextField
                  style={{ width: '100%', marginTop: 16, marginRight: 20 }}
                  id="time"
                  label=""
                  type="time"
                  defaultValue="00:30"
                  value={buffer}
                  onChange={change}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300,
                  }}
                />
              </div>
              <div style={{ width: '100%', marginLeft: 10 }}>
                <span style={{ fontSize: 12, color: '#787878' }}>Limite de Reserva de Posições por Usuário na Semana</span>
                <br />
                <br />
                <Input
                  value={limiteAgendamentosTurnosPorUsuario.toString()}
                  onChange={setLimit}
                  type="number"
                  label=""
                />
              </div>
            </Row>
            <Row>
              <div style={{ width: '100%' }}>
                <strong>Online</strong>
                <Input
                  value={posicoesOnline.toString()}
                  onChange={setposicoesOn}
                  type="number"
                  label={`${'Quantidade de posições a serem liberadas para a categoria Online'}`}
                />
              </div>
              <div style={{ marginRight: 20 }} />
              <div style={{ width: '100%' }}>
                <strong>Online</strong>
                <Input
                  value={qtdQuiosque.toString()}
                  onChange={setQtdQuiosque}
                  type="number"
                  label="Quantidade de reservas a serem realizadas para as Categorias Estoque e/ou Quiosque"
                />
              </div>

            </Row>
            <strong
              style={{ marginTop: 10, marginBottom: 10 }}
            >
              Limites Por Categorias de Locais

            </strong>
            <RowCategory>
              {category?.map((item, index: number) => (
                <Category>
                  <NameCategory>{item.nomeCategoriaLocal}</NameCategory>
                  <Input
                    value={item.limiteReservasGeralPorUsuario || ''}
                    onChange={(value: string) => {
                      setCategory(
                        category?.map((it) => {
                          if (it.codigoCategoriaLocal === item.codigoCategoriaLocal) {
                            it.limiteReservasGeralPorUsuario = value;
                            return it;
                          }
                          return it;
                        }),
                      );
                    }}
                    type="number"
                    label="Limite de reservas por Corretor"
                  />
                  <Input
                    value={item.limiteReservasTurnoManhaPorUsuario || ''}
                    onChange={(value: any) => {
                      setCategory(
                        category?.map((it) => {
                          if (it.codigoCategoriaLocal === item.codigoCategoriaLocal) {
                            it.limiteReservasTurnoManhaPorUsuario = value;
                            return it;
                          }
                          return it;
                        }),
                      );
                    }}
                    type="number"
                    label="Limite de reservas por Corretor - Turno Manhã"
                  />
                  <Input
                    value={item.limiteReservasTurnoTardePorUsuario || ''}
                    onChange={(value: any) => {
                      setCategory(
                        category?.map((it) => {
                          if (it.codigoCategoriaLocal === item.codigoCategoriaLocal) {
                            it.limiteReservasTurnoTardePorUsuario = value;
                            return it;
                          }
                          return it;
                        }),
                      );
                    }}
                    type="number"
                    label="Limite de reservas por Corretor - Turno Tarde"
                  />
                  <Input
                    value={item.limiteReservasTurnoNoitePorUsuario || ''}
                    onChange={(value: any) => {
                      setCategory(
                        category?.map((it) => {
                          if (it?.codigoCategoriaLocal === item?.codigoCategoriaLocal) {
                            it.limiteReservasTurnoNoitePorUsuario = value;
                            return it;
                          }
                          return it;
                        }),
                      );
                    }}
                    type="number"
                    label="Limite de reservas por Corretor - Turno Noite"
                  />
                  {/* <FormControlLabel
                  style={{ marginTop: 18 }}
                  control={(
                    <Checkbox
                      style={{ color: item?.dobraPosicaoPermitida ? 'green' : 'red' }}
                      checked={item.dobraPosicaoPermitida}
                      onChange={() => {
                        setCategory(
                          category?.map((it) => {
                            if (it.codigoCategoriaLocal === item.codigoCategoriaLocal) {
                              it.dobraPosicaoPermitida = !it.dobraPosicaoPermitida;
                              return it;
                            }
                            return it;
                          }),
                        );
                      }}
                      name="checkedA"
                    />
            )}
            label={`Dobrar permissão permetida: ${item.dobraPosicaoPermitida ? '(Sim)' : '(Não)'}`}
                /> */}
                </Category>
              ))}
            </RowCategory>
            <Footer>
              {loading ? (
                <div style={{
                  display: 'flex', justifyContent: 'flex-end', width: '100%', marginRight: 45,
                }}
                >
                  <LoadingCommon />
                </div>
              ) : (
                <Button variant="contained" onClick={() => saveOrEdit()}>
                  Salvar
                </Button>
              )}
            </Footer>
          </Cards>
        )}
      </ContainerComponent>
    </>
  );
};
export default Buffer;
